// extracted by mini-css-extract-plugin
export var grid = "styles-module__grid___VhwmB";
export var gridItem = "styles-module__gridItem___ZZ9Cf";
export var photo = "styles-module__photo____m7QY";
export var photosSection = "styles-module__photosSection___O2cEt";